import React, { useState, useEffect } from 'react';

const SAMPLES_BASE = '/api/samples';

const subjects = [
  { name: 'Lady in Wedding Dress', photo: 'photos/Lady_in_Wedding_Dress.jpg', model: 'models/Lady_in_Wedding_Dress.gif' },
  { name: 'Lady in Black',         photo: 'photos/Lady_in_Black.jpg',          model: 'models/Lady_in_Black.gif' },
  { name: 'Lady in Blue',          photo: 'photos/Lady_in_Blue.jpg',           model: 'models/Lady_in_Blue.gif' },
  { name: 'Man in Suit',           photo: 'photos/Man_in_Suit.jpg',            model: 'models/Man_in_Suit.gif' },
  { name: 'Lady in White',         photo: 'photos/Lady_in_White.jpg',          model: 'models/Lady_in_White.gif' },
  { name: 'Man in Blue',          photo: 'photos/Man_in_Blue.jpg',            model: 'models/Man_in_Blue.gif' },
];

function useColumns() {
  const getColumns = () => {
    if (window.innerWidth <= 600)  return 1;
    if (window.innerWidth <= 1024) return 2;
    return 3;
  };
  const [columns, setColumns] = useState(getColumns);
  useEffect(() => {
    const handle = () => setColumns(getColumns());
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);
  return columns;
}

function SampleCard({ subject, onEnlarge }) {
  const [photoError, setPhotoError] = useState(false);
  const [modelError, setModelError] = useState(false);

  const photoSrc = `${SAMPLES_BASE}/${subject.photo}`;
  const modelSrc = `${SAMPLES_BASE}/${subject.model}`;

  return (
    <div className="card" style={{ overflow:'hidden', padding:0 }}>
      <div style={{ padding:'10px 14px', fontWeight:600, fontSize:14, color:'var(--text)', borderBottom:'1px solid var(--border)' }}>
        {subject.name}
      </div>

      {/* Original Photo */}
      <div style={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', textAlign:'center', padding:'5px 0', background:'#f3f0ff', color:'#6055c5', borderBottom:'1px solid #d9d4f5' }}>
        Original Photo
      </div>
      <div
        onClick={() => !photoError && onEnlarge(photoSrc, subject.name + ' — original photo')}
        style={{ height:300, display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden', cursor: photoError ? 'default' : 'pointer', background:'var(--surface)' }}
      >
        {photoError
          ? <span style={{ color:'var(--text3)', fontSize:12 }}>Photo not available</span>
          : <img
              src={photoSrc}
              alt={subject.name + ' original'}
              onError={() => setPhotoError(true)}
              style={{ width:'100%', height:'100%', objectFit:'contain', objectPosition:'center center', transition:'transform .3s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
            />
        }
      </div>

      {/* 3D Model */}
      <div style={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', textAlign:'center', padding:'5px 0', background:'#edfaf8', color:'#2a9d8f', borderTop:'2px solid var(--border)', borderBottom:'1px solid #c5ede9' }}>
        3D Model
      </div>
      <div
        onClick={() => !modelError && onEnlarge(modelSrc, subject.name + ' — 3D model')}
        style={{ height:300, display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden', cursor: modelError ? 'default' : 'pointer', background:'var(--surface)' }}
      >
        {modelError
          ? <span style={{ color:'var(--text3)', fontSize:12 }}>Model not available</span>
          : <img
              src={modelSrc}
              alt={subject.name + ' 3D model'}
              onError={() => setModelError(true)}
              style={{ width:'auto', height:'100%', maxWidth:'100%', objectFit:'contain', transition:'transform .3s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
            />
        }
      </div>
    </div>
  );
}

export default function SamplesScreen() {
  const [lightbox, setLightbox] = useState(null);
  const columns = useColumns();

  return (
    <div className="page">
      <div style={{ marginBottom:24 }}>
        <div className="page-title">Samples</div>
        <div className="page-sub">See how your photos transform into lifelike 3D figurines</div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:`repeat(${columns}, 1fr)`, gap:'1.5rem' }}>
        {subjects.map(s => (
          <SampleCard key={s.name} subject={s} onEnlarge={(src, alt) => setLightbox({ src, alt })} />
        ))}
      </div>

      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.88)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', cursor:'zoom-out' }}
        >
          <button
            onClick={() => setLightbox(null)}
            style={{ position:'fixed', top:'1rem', right:'1rem', background:'rgba(255,255,255,0.15)', border:'none', color:'#fff', width:36, height:36, borderRadius:'50%', fontSize:'1rem', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}
          >✕</button>
          <img
              src={lightbox.src}
              alt={lightbox.alt}
              onClick={e => e.stopPropagation()}
              style={{ maxWidth:'90vw', maxHeight:'90vh', objectFit:'contain', borderRadius:8 }}
          />
        </div>
      )}
    </div>
  );
}
